// You can write more code here

/* START OF COMPILED CODE */

import EntitySmashable from '../../EntitySmashable';
/* START-USER-IMPORTS */
import { CharacterSkinsValues } from '../../../CharacterSpine';
/* END-USER-IMPORTS */

export default class EntitySmashableVine extends EntitySmashable {
  constructor(scene: Phaser.Scene, x?: number, y?: number) {
    super(scene, x ?? 45, y ?? 169);

    // vine
    const vine = scene.add.image(0, 0, 'game-all', 'smashable-vine.png');
    this.add(vine);

    // icon
    const icon = scene.add.image(0, 6, 'game', 'icon-grizz.png');
    icon.scaleX = 0.8;
    icon.scaleY = 0.8;
    this.add(icon);

    // icon1
    const icon1 = scene.add.image(0, -78, 'game', 'icon-grizz.png');
    icon1.scaleX = 0.8;
    icon1.scaleY = 0.8;
    this.add(icon1);

    // icon2
    const icon2 = scene.add.image(0, 90, 'game', 'icon-grizz.png');
    icon2.scaleX = 0.8;
    icon2.scaleY = 0.8;
    this.add(icon2);

    this.vine = vine;
    this.icon = icon;
    this.icon1 = icon1;
    this.icon2 = icon2;

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  private vine: Phaser.GameObjects.Image;
  private icon: Phaser.GameObjects.Image;
  private icon1: Phaser.GameObjects.Image;
  private icon2: Phaser.GameObjects.Image;

  /* START-USER-CODE */

  public reset(allowedCharacter?: CharacterSkinsValues) {
    super.reset(allowedCharacter);
    let iconCharacter = allowedCharacter ? allowedCharacter : this.allowedCharacter;

    this.icon.setFrame(EntitySmashableVine.iconLookup.get(iconCharacter) ?? EntitySmashableVine.defaultIcon);
    this.icon1.setFrame(EntitySmashableVine.iconLookup.get(iconCharacter) ?? EntitySmashableVine.defaultIcon);
    this.icon2.setFrame(EntitySmashableVine.iconLookup.get(iconCharacter) ?? EntitySmashableVine.defaultIcon);
  }

  protected injectMatter(target: Phaser.GameObjects.GameObject) {
    this.setSize(this.vine.displayWidth, this.vine.displayHeight - 20);

    super.injectMatter(target);
  }

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
